'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsage$002dItem from "./presto.types$-Credential-Usage-Item.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsageItem$() {
}
export { $c_Lpresto_types$CredentialUsageItem$ as $c_Lpresto_types$CredentialUsageItem$ };
$p = $c_Lpresto_types$CredentialUsageItem$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsageItem$;
/** @constructor */
function $h_Lpresto_types$CredentialUsageItem$() {
}
export { $h_Lpresto_types$CredentialUsageItem$ as $h_Lpresto_types$CredentialUsageItem$ };
$h_Lpresto_types$CredentialUsageItem$.prototype = $p;
$p.l = (function() {
  return "CredentialUsageItem";
});
$p.cFL = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCredential$002dUsage$002dItem.$c_Lpresto_types$CredentialUsageItem(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$CredentialUsageItem$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsageItem$, "presto.types$CredentialUsageItem$", ({
  Zq: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$CredentialUsageItem$ as $d_Lpresto_types$CredentialUsageItem$ };
var $n_Lpresto_types$CredentialUsageItem$;
function $m_Lpresto_types$CredentialUsageItem$() {
  if ((!$n_Lpresto_types$CredentialUsageItem$)) {
    $n_Lpresto_types$CredentialUsageItem$ = new $c_Lpresto_types$CredentialUsageItem$();
  }
  return $n_Lpresto_types$CredentialUsageItem$;
}
export { $m_Lpresto_types$CredentialUsageItem$ as $m_Lpresto_types$CredentialUsageItem$ };
//# sourceMappingURL=presto.types$-Credential-Usage-Item$.js.map
